// import { isLoginAndRealName } from '../../CommonVar.js';
import Util from "../util.js";
import { getTempInfo,setStorage ,getStorage} from '../common.js';
import {isLogin,getUserInfoList} from './loginAction.js'
import { Toast } from 'antd-mobile/lib';

import { getLoginState} from '../getPay.js';


const ToastTime = Util.ToastTime;
//投顾状态
export function superFundAccAgreementState(text) {
  return {
    type: "SUPER_ACCA_AGREEMENT_STATE",
    text: text
  }
}
//签约状态标志 fzy
export function signingAlreadyState(text) {
  return {
    type: "SIGNING_ALREADY_STATE",
    text: text
  }
}
//答题的id fzy
export function setActivityId(text) {
  return {
    type: "ACTIVITY_ID",
    text: text
  }
}

/*投顾状态查询 /api/advisor/querySuperFundAccAgreement*/
export function querySuperFundAccAgreement(data,successCallback,errorCallback){
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then( (d)=>{
      data.token=d;
      Util.get(Util.url+"/api/advisor/querySuperFundAccAgreement",data,function(result){
        if (result.code=='0000') {
          successCallback(result.content)
          dispatch(signingAlreadyState(result.content))
        }else{
          errorCallback(result.message)
        }
        console.log(result)
      },function(error){
        console.log(error);
          // errorCallback(error)
      })
    })
  }
}

// export function querySuperFundAccAgreement(data,callBack){
//   return function(dispatch, getState) {
//     getTempInfo( 'shortToken' ).then( (d)=>{
//       data.token=d;
//       Util.get(Util.url+"/api/advisor/querySuperFundAccAgreement",data,function(result){
//         if (result.code=='0000') {
//           callBack(result)
//         }else{
//           callBack(result)
//         }
//         console.log(result)
//       },function(error){

//       })
//     })
//   }
// }


/*投顾授权、签约、解约/api/advisor/signSuperFundAccAgreement 参数: token、 state(0，解约；1，签约；2，授权) 、operator(user)*/
export function signSuperFundAccAgreement(data,callBack){
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then( (d)=>{
      data.token=d;
      Util.get(Util.url+"/api/advisor/signSuperFundAccAgreement",data,function(result){
        if (result.code=='0000') {
          callBack(result)
        }else{
          Toast.info( result.message, Util.ToastTime );
          // callBack(result)
        }
        console.log(result)
      },function(error){
          console.log(error,"signSuperFundAccAgreement")
          Toast.info( Util.errorTxt, Util.ToastTime );
      })
    })
  }
}
/*智投组合可转换基金接口 fzy */
export function querySuperfundUpdateList(callBack) {
  return function(dispatch,getState) {
    getTempInfo('shortToken').then( (d)=>{
      let data= {token: d};
      Util.get(Util.url+"/api/superfund/querySuperfundUpdateList",data,function(result){
        if (result.code == '0000') {
          console.log(result);
          callBack(result.content);
        }else{
          Toast.info( result.message, Util.ToastTime );
        }
      },function(error){
        console.log(error);
      })
    }).catch((err)=>console.log(err))
  }
}

/**智投组合升级弹窗控制标识 */
export function upgradeControl(text){
  return {
    type: "UPGRADE_CONTROL",
    text: text
  }
}

/*查询是否开放升级功能 */
export function validateSuperFundUpdateAction(text) {
  return {
    type: "VALIDATE_SUPERFUND_UPDATE_ACTION",
    text: text
  }
}
export function validateSuperFundUpdate(data,callBack,_this) {
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      Util.get(Util.url+"/api/superfund/validateSuperFundUpdate",data,function(result){
        if (result.code=='0000') {
          console.log(result.content,"查询是否开放升级功能")
          dispatch(validateSuperFundUpdateAction(result.content))
          if(callBack){
            callBack(result.content)
          }
        }else{
           Toast.info( result.message, Util.ToastTime );
        }
 
      },function(error){
        Toast.info( Util.errorTxt, Util.ToastTime );
      })
    }).catch( (err)=>{ console.log(err) } )
  }
}

/*智投升级预览*/
export function redeemToSuperFundPreview(text) {
  return {
    type: "REDEEM_TO_SUPER_FUND_PREVIEW",
    text: text
  }
}
export function getredeemToSuperFundPreview(data,callBack,_this) {
  return function(dispatch, getState) {
    Toast.loading('', 0, () => {});
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      Util.get(Util.url+"/api/superfund/redeemToSuperFundPreview",data,function(result){
        if (result.code=='0000') {
          Toast.hide();
          let data1=JSON.parse( JSON.stringify(result.content.previewItemFunds) );
          for (var i = 0; i < data1.length; i++) {
            console.log(i)
            if (data1[i].srcRegularRate==null) {
              data1.splice(i,1)
              i-=1;
              continue;
            }
            console.log(i)

            for (var j = i+1; j < data1.length; j++) {
              if (data1[i].styleTypeName==data1[j].styleTypeName) {
                if (Object.prototype.toString.call(data1[j].srcRegularRate)=="[object Number]") {
                  data1[i].srcRegularRate=data1[i].srcRegularRate+data1[j].srcRegularRate;
                }
                data1.splice(j,1)
                j-=1;
              } 
            }
          }
          data1.sort(getVal('srcRegularRate'))
          result.content.previewItemFundsChart=data1;
          dispatch(redeemToSuperFundPreview(result.content))
          if(callBack){
            callBack(result.content)
          }
        }else{
          Toast.info( result.message, Util.ToastTime );
        }
 
      },function(error){
        Toast.info( Util.errorTxt, Util.ToastTime );
      })
    }).catch( (err)=>{ console.log(err) } )
  }
}

// /*预校验升级业务*/
// export function validateRedeemToSuperFund(text) {
//   return {
//     type: "VALIDATE_REDEEM_TO_SUPER_FUND",
//     text: text
//   }
// }
export function getvalidateRedeemToSuperFund(data,callBack,_this) {
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      Util.get(Util.url+"/api/superfund/validateRedeemToSuperFund",data,function(result){
        if (result.code=='0000') {
          console.log(result.content,"预升级校验")
          if(callBack){
            callBack(result.content)
          }
        }else{
          Toast.info( result.message, Util.ToastTime );
        }
      },function(error){
        Toast.info( Util.errorTxt, Util.ToastTime );
      })
    }).catch( (err)=>{ console.log(err) } )
  }
}

 /*智投升级*/
export function getredeemToSuperFund(data,callback) {
  return function(dispatch, getState) {
    Toast.loading('', 0, () => {});
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d; 
        dispatch(validateTransactionPassword(data,(c)=>{
          if (!c) { Toast.info( '交易密码错误', Util.ToastTime );callback(2);;return;}
                Toast.hide();
                Util.post(Util.url+"/api/superfund/redeemToSuperFund",data,function(result){
                  if (result.code=='0000') {
                    callback(1,result);
     
                  }else{
                    callback(3,result.message);
    
                  }
                  console.log(result)
                },function(error){
                  callback(3,Util.errorTxt);
       
                })

        },(m)=>{
            Toast.info( m, Util.ToastTime );
        })) 
     
    }).catch( (err)=>{ console.log(err) } )
  }
}

/*答题活动*/
export function AnswerSecKill(data,callBack){
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then( (d)=>{
      data.token=d;
      Util.get(Util.url+"/api/seckill/secKillSubmit",data,function(result){
        if (result.code=='0000') {
          callBack(result)
        }else{
          callBack(result)
        }
        console.log(result)
      },function(error){

      })
    })
  }
}
/*根据id获取答题活动-新*/
export function getActivityById(data,callBack){
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then( (d)=>{
      data.token=d;
      Util.get(Util.url+"/api/point/getActivityById",data,function(result){
        if (result.code=='0000') {
          callBack(result)
        }else{
          callBack(result)
        }
       
        console.log(result)
      },function(error){

      })
    })
  }
}
/*答题活动*/
export function AnswerSubmit(data,callBack){
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then( (d)=>{
      data.token=d;
      Util.get(Util.url+"/api/point/savePointAnswers",data,function(result){
        if (result.code=='0000') {
          callBack(result)
        }else{
          callBack(result)
        }
        console.log(result)
      },function(error){

      })
    })
  }
}

//调仓确认
export function getUpdateSeason(data,callback) {
  return function(dispatch, getState) {
    Toast.loading('', 0, () => {});
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      console.log('调仓确认:',data)
      dispatch(validateTransactionPassword(data,(c)=>{
        if (!c) {Toast.hide();Toast.info( '交易密码错误', Util.ToastTime );callback(2);return;}
         Util.post(Util.url+"/api/superfund/updateSeason",data,function(result){
          Toast.hide()
          if (result.code=='0000') {
            callback(1,result);
          }else{
            callback(3,result.message);
          }
        },function(error){
          callback(3, Util.errorTxt);
          Toast.hide();
        })
      },(m)=>{
        callback(2)
        Toast.hide();
        Toast.info( m, Util.ToastTime );
      }))
     
    }).catch( (err)=>{ Toast.hide() } )
  }
}
export function getwebLogin(data,callback) {
  return function(dispatch, getState) {
      Util.get(Util.url+"/api/v1/login/camcWebLogin",data,function(result){
        console.log(result,'------------------')
        if(result.code == "0000"){
            let TM=new Date()
            setStorage('currentUserInfo', result.content);
            setStorage('loginInfo-shortToken',result.content.shortToken);
            setStorage('loginInfo-longToken',result.content.longToken);
            setStorage('tokenTimeLong',TM.getTime()+window.tokenTimeLong);
            setStorage('tokenTimeshort',TM.getTime()+window.tokenTimeshort);
            dispatch(getUserInfoList()); 
          if (result.content.isProxySale) {
            //纯代销
            setStorage('loginState', '0');//0
            callback(result)
          }else if(result.content.hasCwimAccount){
            setStorage('loginState', '2');
            callback(result)
          }else if(result.content.hasCwimAccount===false){
              setStorage('loginState', '3');
              dispatch(syncAccountName(result.content.name));
              dispatch(syncAccountLoginType(result.content.certType));
              dispatch(syncAccountLoginNo(result.content.certNo));
            callback(result)
          }
        }else{
          setStorage('loginState', '0');//1
        }
      },function(error){
          setStorage('loginState', '0');//1
      })
  }
}
//import Store from '../ReduxStore';
export const bindingMobile = (verifyParam, loginContent ,succallback, errcallback) => {
  return async (dispatch, getState)=>{
    Toast.loading('', 0, () => {});
    const successCallback = (succ)=>{
          Toast.hide()
      console.log(succ);
      if(succ && succ.code === '0000'){
        
          succallback();
      }else{
        console.log('后台返回数据有误！' + succ.message);
          errcallback(succ.message);
      }
    };
    const errorCallback = (err)=>{
          Toast.hide()
        console.log(err);
        errcallback(Util.errorTxt);
    };
    Util.get(Util.url + '/api/account/bindingMobileNo', verifyParam, successCallback, errorCallback);
  }
}
//同步开户传入参数：证件类型
export const syncAccountLoginType = (text) => {return { type: 'SYNC_ACCOUNT_LOGIN_TYPE', text}} ;

//同步开户传入参数：证件号码
export const syncAccountLoginNo = (text) => {return { type: 'SYNC_ACCOUNT_LOGIN_NO', text}};

//同步开户传入参数：交易密码
export const syncAccountTradePw = (text) => {return { type: 'SYNC_ACCOUNT_TRADE_PASSWORD', text}};

//同步开户传入参数：登录密码
export const syncAccountLoginPw = (text) => {return { type: 'SYNC_ACCOUNT_LOGIN_PASSWORD', text}};

//同步开户传入参数：手机号
export const syncAccountMobileNo = (text) => {return { type: 'SYNC_ACCOUNT_MOBILE_NO', text}};

//同步开户传入参数：短信请求编码
export const syncAccountRequestId = (text) => {return { type: 'SYNC_ACCOUNT_REQUEST_ID', text}};

//同步开户传入参数：姓名
export const syncAccountName = (text) => {return { type: 'SYNC_ACCOUNT_NAME', text}};

//同步开户传入参数：邀请码
export const invitationCode = (text) => {return { type: 'INVITATION_CODE', text}};

export const mergeObjectEasy = (oldObj, newObj)=>{
  return Object.assign({}, oldObj, newObj);
}
export const syncAccount = (paramsInit, succallback, errcallback) => {
  return async (dispatch, getState) => {
    let currentUserInfo= await getStorage('currentUserInfo');
    // getTempInfo( 'shortToken' ).then((data) => {
      // paramsInit.token = data;
      Toast.loading('', 0, () => {});
      console.log(sessionStorage)
      let paramsLS ={
        // loginNo:currentUserInfo.certNo,
        // loginType:currentUserInfo.certType,
        // mobileNo:getState().mobileNo?getState().mobileNo:sessionStorage.sync.split(',')[0],
        // requestId:getState().requestId?getState().requestId:sessionStorage.sync.split(',')[1],
        // name:currentUserInfo.name,
        // invitationCode: getState().invitationCode?getState().invitationCode:sessionStorage.sync.split(',')[2],
        invitationCode: "",
        clientType:Util.return_Clinet_Type()
      }
      let params = mergeObjectEasy(paramsLS, paramsInit);
      const successCallback = async (succ)=>{
        console.log(succ);
        Toast.hide()
        if(succ && succ.code === '0000'){
              let userInfo = {
                userId: succ.content.userId,
                isRealName: succ.content.tradeAccountNo ? true : false
              }
              if (succ.content.tradeAccountNo) {
                setStorage('loginState', '2');
              } else {
                setStorage('loginState', '1');
              }
              if(succ.content.name != undefined)
                userInfo = mergeObjectEasy(userInfo, {name: succ.content.name});
              if(succ.content.nickName != undefined)
                userInfo = mergeObjectEasy(userInfo, {nickName: succ.content.nickName});
              if(succ.content.tradeAccountNo != undefined)
                userInfo = mergeObjectEasy(userInfo, {tradeAccountNo: succ.content.tradeAccountNo});
                userInfo.mobileNo = params.mobileNo;
              console.log('同步开户后userInfo', userInfo);
              let user = await getTempInfo('userList-'+userInfo.userId);
              if(user!=9999){
                userInfo = mergeObjectEasy(user, userInfo);
              }
              
              setStorage('currentUserInfo', userInfo);
              setStorage('userList-' + userInfo.userId, userInfo);
              setStorage('loginInfo-shortToken', succ.content.shortToken);
              setStorage('loginInfo-longToken', succ.content.longToken);
              dispatch(getUserInfoList()); 
              dispatch(isLogin(true));
              succallback(succ.content);
        }else{
            console.log('后台返回数据有误!');
            errcallback(succ.message);
        }
      };
      const errorCallback = (err)=>{
          Toast.hide()
          console.log(err);
          errcallback(Util.errorTxt);
      };
      // console.log(getState());
      // console.log(getState().synchAccountParam);
      // params.tradePassword = tradePassword;
      console.log(params);
      Util.post(Util.url + '/api/account/openCucAndCwimAccount', params, successCallback, errorCallback);
    // })
    // .catch( (err)=>{
    //   console.log(err)
    //   Toast.info(Util.errorTxt, Util.ToastTime);
    // });
    
  }
}
//获取年龄情况
export function validateAgeUserCertNo(params, callback, errBack) {
  return function(dispatch, getState) {
    console.log(params);
    Util.get(Util.url+"/api/account/validateAgeUserCertNo", params, function(responseText){  
      console.log(responseText) 
      callback(responseText);
    }, function(err){
      // errBack();
      Toast.info(Util.errorTxt, 2);
    })
  }
}
//验证手机号
export const verifyPhone = (verifyParam, succallback, errcallback, flag = false) => {
  return async (dispatch, getState)=>{
    Toast.loading('', 0, () => {});
    const successCallback = (succ)=>{
          Toast.hide()
      console.log(succ);
      if(succ && succ.code === '0000'){
          succallback();
      }else{
        console.log('后台返回数据有误！' + succ.message);
          errcallback(succ.message);
      }
    };
    const errorCallback = (err)=>{
          Toast.hide()
        console.log(err);
        errcallback(Util.errorTxt);
    };
    dispatch(syncAccountMobileNo(verifyParam.mobileNo));
    dispatch(syncAccountRequestId(verifyParam.requestId));
    Util.get(Util.url + '/api/mobileCaptcha/validateMobileCaptcha', verifyParam, successCallback, errorCallback);
  }
}
//是否有税收
export const getCrsDetail = (succallback, errcallback) => {
  return async (dispatch, getState)=>{
    // dispatch(pageFlag(true));
    const successCallback = (succ)=>{
      // dispatch(pageFlag(false));
      console.log(succ);
      if(succ && succ.code === '0000'){
          succallback(succ.content);
      }else{
          errcallback(succ.message);
      }
    };
    const errorCallback = (err)=>{
      // dispatch(pageFlag(false));

        errcallback(Util.errorTxt);
    };

    let currentUserInfo= await getStorage('currentUserInfo');
    console.log(currentUserInfo,1111121)
    let params={
      certNo:currentUserInfo.certNo,
      certType:currentUserInfo.certType,
    }
    Util.post(Util.url + '/api/account/getCrsDetail', params, successCallback, errorCallback);
  }
}
//验证手机号是否已经注册
export const verifyRegisterPhone = (params, succallback, errcallback, revcallback = null)=>{
  return (dispatch, getState)=>{
    const successCallback = (suc)=>{
      if(suc && suc.code === '0000'){
        console.log('手机号没注册过');
        succallback(params.mobileNo);
      }else{
        console.log('手机号注册过');
        if((suc.message.indexOf('手机号已注册') != -1) && revcallback){
          revcallback(params.mobileNo);
          return;
        }
        errcallback(suc.message);
      }
    };
    const errorCallback = (err)=>{
      errcallback(Util.errorTxt);
    };
    Util.get(Util.url + '/api/account/validateMobileHasRegister', params, successCallback, errorCallback);
  }
}
//获取手机验证码
export const getVerifyCode = (mobileNo, callback) => {
  return (dispatch, getState)=>{
    const successCallback = (succ)=>{
      if(succ && succ.code == '0000'){
        console.log(succ);
        callback(succ.content);
      }else{
        console.log(succ);
        console.log('后台返回数据有误!');
        callback('');
      }
    };
    const errorCallback = (err)=>{
      console.log(err);
      callback('');
    };
    Util.post(Util.url + '/api/mobileCaptcha/sendMobileCaptcha', {mobileNo}, successCallback, errorCallback);
  }
}
//登录后-获取手机验证码 20-3-12
export const realUserMobileCaptcha = (params, callback) => {
	return (dispatch, getState)=>{
		getTempInfo('shortToken' ).then( (d)=>{
			params.token = d;
			console.log(params);
			const successCallback = (succ)=>{
				if(succ && succ.code == '0000'){
					console.log(succ);
					callback(succ.content);
				}else{
					console.log(succ);
					// Toast.show(succ.message, getToastConfPoint());
					console.log('后台返回数据有误!');
					callback('');
				}
			};
			const errorCallback = (err)=>{
				console.log(err);
				callback('');
			};
		Util.post(Util.url + '/api/mobileCaptcha/realUserMobileCaptcha', params, successCallback, errorCallback);
	} ) .catch( (err)=>{ console.log(err) } )
	}
}
/* 智投首页*/
export function SupperFundHome(text){
  return {
    type:"SUPPER_FUND_HOME",
    text:text
  }
}
export const validateTransactionPassword = (params, succallback, errcallback)=>{
  return (dispatch, getState)=>{
    const successCallback = async (succ)=>{
      console.log(succ);
      if(succ && succ.code === '0000'){
          succallback(succ.content);
      }else{

        console.log('后台返回数据有误！' + succ.message);
          errcallback(succ.message);
      }
    };
    const errorCallback = (err)=>{

        console.log(err);
        errcallback(Util.errorTxt);
    };
    Util.post(Util.url + '/api/account/validatePassword', params, successCallback, errorCallback);
  }
}
//当前基金是否开放
export function getFundIsOpen(data,callBack) {
  return function(dispatch, getState) {
    console.log('当前基金是否开放:',data)
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      Util.get(Util.url+"/superfund/buy/getBuyFee",data,function(result){
        if (result.code=='0000') {
          
        }else{
          callBack(result.message)

        }
        console.log(result)
      },function(error){

      })
    }).catch( (err)=>{ console.log(err) } )
  }
}
//继续投资
export function buySubmit(data,callback) {
  return function(dispatch, getState) {
    Toast.loading('', 0, () => {});
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      data.clientType=Util.return_Clinet_Type();

      console.log('购买入参:',data)
      dispatch(validateTransactionPassword(data,(c)=>{
        console.log(c,"8988989889898989")
        if (!c) {Toast.hide();Toast.info( '交易密码错误', Util.ToastTime,()=>{} );callback(0,"");return;}
        Util.post(Util.url+"/api/v1/superFund/buy",data,function(result){///superfund/buy/submit
          console.log(result,"1111111")
          Toast.hide();
          if (result.code=='0000') {
            if(data.textval=="直销卡"){
              callback(result.content.requestDetail.paymentState,result)
            }else{
              callback(1,result)
            }
          }else{
            callback(0,result.message);
          }
        },function(error){
          callback(0,Util.errorTxt);
          Toast.hide();
        })
      },(m)=>{
        Toast.info( m, Util.ToastTime );
        callback(0,Util.ToastTime)
      }))
    }).catch( (err)=>{ Toast.hide() } )
  }
}
//获取三货基详情
export function getFundsInfo(callback){
  return function(dispatch, getState){
    Toast.loading('', 0, () => {});
    Util.get(Util.url+"/api/trade/getFundsInfo",{},function(result){
      Toast.hide()
      if (result.code=='0000') {
        if (callback) {
          callback(result)
        }
      }
    },function(error){
        Toast.hide()
    });
  }
}
//获取智投赎回到账日
export function getExpectedDate(data,callback){
  return function(dispatch, getState){
    Util.get(Util.url+"/superfund/redeem/getExpectedDate",data,function(result){
      console.log(result);
      if (result.code=='0000') {
        if (callback) {
          callback(result)
        }
      }
    },function(error){
      console.log(error);
    });
  }
}

//赎回
export function getDoRedeemSuper(data,callback) {
  return function(dispatch, getState) {
    Toast.loading('', 0, () => {});
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      console.log('super redeem入参:',data);
      dispatch(validateTransactionPassword(data,(c)=>{
        if (!c) {Toast.info( '交易密码错误', Util.ToastTime );callback(0);return;}
        Util.post(Util.url+"/superfund/redeem/submit ",data,function(result){
          Toast.hide();
          if (result.code=='0000') {
            callback(1,result);
          } else if(result.code=='1111'){
            Toast.info(result.message, Util.ToastTime );
            callback(2,result);
          }else{
            callback(3,result.message);
          }
        },function(error){
          Toast.hide();
          callback(3,Util.errorTxt);
        })
      },(m)=>{
        callback(2)
        Toast.info( m, Util.ToastTime );
      }))
    }).catch( (err)=>{ Toast.hide() } )
  }
}
//智投组合七日惩罚性赎回判断
export function superFundPunishmentIn7Day(data,callback){
  return function(dispatch, getState) { 
    Toast.loading('', 0, () => {});
    getTempInfo('shortToken').then( (d)=>{ 
      data.token = d;
      Util.get(Util.url+"/api/trade/superFundPunishmentIn7Day",data,function(result){
        Toast.hide()
        console.log(result)
        if (result.code=='0000') {
          callback(result)
        } else {
           Toast.info(result.message, Util.ToastTime );
        }
      },function(error){
        Toast.hide();
        console.log(error)
      })
    }).catch( (err)=>{
      Toast.hide()
    })
  }
}

export function getSupperFundHome(data,callback,_this) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      if(token === null || token === "" || token === undefined) {
        console.log("token为空");
      }else {
        data.token = token;
        Util.get(Util.url+"/superfund/supperFund/homePage",data,function(data){
          
          if(data.code == "0000"){
            dispatch(SupperFundHome(data.content));
            callback(data.content)
          }else{
            //let toast = Toast.show(data.message, getToastConfPoint( ) );
          }
        },function(error){
          console.log(error)
          //let toast = Toast.show(Util.errorTxt, getToastConfPoint( ) );
        
        })
        /*start*/
        // let dataTemp = homeJson;
        // if(dataTemp.code == "0000"){
        //     dispatch(SupperFundHome(dataTemp.content));
        //     callback(dataTemp.content)
        // }
        /*end*/
      }
    }).catch( (err)=>{
      //let toast = Toast.show(Util.errorTxt, getToastConfPoint( ) ); 
    });
  }
}


/*组合分析（绩效归因分解）*/
export function getFindAssetConfig(data,callBack,_this) {
  return function(dispatch, getState) {
    // getTempInfo( 'shortToken' ).then( (d)=>{ 
    //   let newData=data;
    //   newData.token=d;
    //   console.log('checkNeedUpdate:',newData)
      Util.get(Util.url+"/api/superfund/findAssetConfig",data,function(result){
        if (result.code=='0000') {
         callBack(result.content)
        }else{
          Toast.info(result.message, Util.ToastTime );
        }
      },function(error){
        // alert(error)
        // Toast.info(Util.errorTxt, Util.ToastTime );
      })
    // }).catch( (err)=>{ console.log(err) } )
  }
}


let homeJson = {"code":"0000","message":null,"content":{"allIncome":"5.52","dayIncome":"5.65","riskType":null,"deadLine":"2017-07-31","singleSuperFundViews":[{"adjustFlag":false,"allIncome":"1.93","buyFlag":null,"currentAsset":401.25,"dayIncome":"0.93","redeemFlag":false,"superFundCode":"SF1005","superFundName":"锐意进取组合","thirtyIncome":null,"deadLine":"2017-07-31"},{"adjustFlag":false,"allIncome":"3.61","buyFlag":null,"currentAsset":2005.56,"dayIncome":"4.73","redeemFlag":false,"superFundCode":"SF1011","superFundName":"常青藤大学组合","thirtyIncome":null,"deadLine":"2017-07-31"}],"totalAssets":2406.81,"transitAssets":0.0,"problemList":{"content":{"total":4,"rows":[{"content":"一分钟了解华夏智投","title":"<p>华夏智投组合是在华夏基金19年资产管理经验的基础上，融入AI智能算法倾力打造的智能投资组合。基于客户不同阶段的财富目标，提供一键式、智能化的资产配置整体解决方案。</p>\n<p>华夏智投组合为客户提供教育金智投、时光智投和资产增值智投三个系列，共9个组合，可以满足客户资产增值、教育、养老等多方面的投资需求，客户可以根据自身需要，选择不同的智投组合。</p>\n","bq":[{"tagName":"智投介绍","cjwtId":1493,"tagId":"WT_TAG_1492"}],"orderFlag":1,"NUM":1,"pageValid":"1","key":1493},{"content":"查理机器人介绍","title":"<p>查理是汇聚华夏基金多年丰富的主动资产管理和海外资产配置经验，为您精心打造的智投机器人，查理将利用互联网技术与AI智能算法，为客户提供财务目标规划、生成资产配置解决方案、组合全周期管理的一站式智投服务，让每个客户都享受到私人银行般的服务。</p>\n","bq":[{"tagName":"智投介绍","cjwtId":1596,"tagId":"WT_TAG_1492"}],"orderFlag":2,"NUM":2,"pageValid":"1","key":1596},{"content":"创建智投组合的方式","title":"<p>您只需要两步就能创建属于您的智投组合：</p>\n<p>1、华夏智投包括教育、养老和资产增值三种场景，您可以根据自身需要选择智投组合。您也可以通过智投计算器来测算一下，获得推荐组合和投资方案；</p>\n<p>2、 进入智投组合详情页后，只需要点击“一键投资”按钮，完成支付即可。购买组合一般需要两天的时间，购买后请随时关注组合调仓情况，及时跟踪调仓。</p>\n<p></p>\n","bq":[{"tagName":"智投介绍","cjwtId":1495,"tagId":"WT_TAG_1492"}],"orderFlag":3,"NUM":3,"pageValid":"1","key":1495},{"content":"智投计算器有什么用？","title":"<p>智投计算器是帮助客户根据目前的所处阶段（例如客户年龄、当前养老储备金、预期每年养老金需求，或者孩子年龄、当前教育储备金等），计算客户养老金或者教育金缺口及所需投资金额。</p>\n","bq":[{"tagName":"智投介绍","cjwtId":1771,"tagId":"WT_TAG_1492"}],"orderFlag":4,"NUM":4,"pageValid":"1","key":1771}]}}}}

/* 在途资金明细, http://10.16.0.240/hxcfapp_dev/api/superfund/queryTransitRecords */
export function QueryTransitRecords(text){
  return {
    type:"QUERY_TRANSIT_RECORDS",
    text:text
  }
}

export function getQueryTransitRecords(data,callback,_this) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      data.token = token;
      Util.get(Util.url+"/api/superfund/queryTransitRecords",data,function(data){
        if(data.code == "0000"){
          dispatch(QueryTransitRecords(data.content));
   
            //dispatch(pageFlag(false));
          callback(data.content)
        }else{
          Toast.info(data.message, Util.ToastTime );
          //let toast = Toast.show(data.message, getToastConfPoint( ) );
        }
      },function(error){
        console.log(error,"错误信息")
        //let toast = Toast.show("网络异常，请检查您的网络", getToastConfPoint( ) );
      
      })
    }).catch( (err)=>{
      //let toast = Toast.show(Util.errorTxt, getToastConfPoint( ) );
    
    });

  }
}

/*历史交易记录*/
export function TransformationFunList(text){
  return {
    type:"TRANSFORMATION_FUN_LIST",
    text:text
  }
}

// 协议初始值
export function Xeyi(text){
  return {
    type:"XEYI",
    text:text
  }
}

export function getTransformationHistory(data,callbackData,_this) {
  return function(dispatch, getState) {
    //dispatch(pageFlag(true))
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      // let data={
      //   token:d,
      //   fundCode:fundCode,
      //   pageSize:pageSize,
      //   pageIndex:pageIndex,
      //   businessType:businessType
      // }
      data.token = d;
      Util.get(Util.url+"/api/myAsset/historyTradeQuery",data,function(result){
        if (result.content==null) {
          Toast.info(result.message, Util.ToastTime );
        } else {
          let newData=result.content.records.filter((item)=>{
            return item.fundName.endsWith('组合')||Util.superFundNameArr.indexOf(item.fundName) > -1||item.businessType=="TC24"
          })
          console.log(newData,123)
          result.content.records=newData;
          callbackData(result.content)
        }
        if(_this){
          _this.setState({
            loadingFlag:false
          })
        }
      },function(error){
        Toast.info(Util.errorTxt, Util.ToastTime );
        if(_this){
          _this.setState({
            loadingFlag:false
          })
        }

      })
    }).catch( (err)=>{
      if(_this){
        _this.setState({
          loadingFlag:false
        })
      }

    })
  }
}


/*交易记录详情*/
export function tradeDetail(text){
  return {
    type:"TRADE_DETAIL",
    text:text
  }
}
export function getTradeDetail(data,callbackData,_this) {
  return function(dispatch, getState) { 
    getTempInfo('shortToken').then( (d)=>{ 
      data.token = d;
      Util.get(Util.url+"/api/myAsset/historyTradeDetail",data,function(result){
        if (result.content==null) {
          
        } else {
          dispatch(tradeDetail(result.content))
          callbackData(result.content)
        }
      },function(error){
        console.log(error)
 
      })
    }).catch( (err)=>{

    })
  }
}

/*历史确认详情*/
export function historyConfirmDetail(data,callbackData) {
  return function(dispatch, getState) {
   
    getTempInfo('shortToken').then( (d)=>{ 
      data.token = d;
      Util.get(Util.url+"/api/myAsset/historyConfirmDetail",data,function(result){
        if (result.content==null) {
          Toast.info(result.message, Util.ToastTime );
        } else {
          dispatch(tradeDetail(result.content))
          callbackData(result.content)
        }
      },function(error){
        
      })  
    }).catch( (err)=>{
      
    })
  }
}


// 往期报告
export function Wangqi(data,callbackData) {
  return function(dispatch, getState) {
   
    getTempInfo('shortToken').then( (d)=>{ 
      data.token = d;
      console.log(Util.url+"/api/v1/superfund/product/stopProfit/historyReport/getHistoryReportList",data)
      Util.get(Util.url+"/api/v1/superfund/product/stopProfit/historyReport/getHistoryReportList",data,function(result){
        if (result.content==null) {
          Toast.info(result.message, Util.ToastTime );
        } else {
          callbackData(result.content)
        }
      },function(error){
        
      })  
    }).catch( (err)=>{
      
    })
  }
}

/*看是否用户是否持有有超级基金产品*/
export function userHasInvested(text){
  return {
    type:"QUERY_INCOME",
    text:text
  }
}
export function hqtXz(text){
  return {
    type:"HQT_XZ",
    text:text
  }
}
export function smSzt(text){
  return {
    type:"SMS_ZT",
    text:text
  }
}
export function HasInvested(data,callBack) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      data.token = token;
      Util.get(Util.url+"/superfund/account/hasInvested",data,function(result){
        if(result.code == "0000"){
          dispatch(userHasInvested(result.content.invested))
          callBack(result.content)
        }else{
          Toast.info(result.code, Util.ToastTime );
        }
      },function(error){
          Toast.info(Util.errorTxt, Util.ToastTime );
      })
    }).catch( (err)=>{
    });
  }
}

//智投百科
export function encyclopediaAction(text) {
  return {
    type: "ENCYCLOPEDIA_ACTION",
    text: text
  }
}


//获取智投百科
export function getEncyclopedia(params, callBack) {
  return function(dispatch, getState) {
  	Util.get(Util.url + "/api/cms/getQuestionListByCode", params, (data) => {
      dispatch(encyclopediaAction(data.content.rows));
      console.log("智投百科");
      console.log(data);
      callBack(data);
  	}, (err) => {
  		console.log("错误信息" + err);
  	});
  }
}

//风险测评数据
export function riskEvaluationPieData(text) {
	return {
		type: "RISK_EVALUATIONPIE_DATA",
		text: text
	}
}

//获取风险测评数据
export function getRiskEvaluationPieData(params, callBack) {
  return function(dispatch, getState) {
  	getTempInfo("shortToken").then((token) => {
	  	params.token = token;
	  	Util.get(Util.url + "/superfund/account/saveRiskRank", params, (data) => {
	  	  if(data.code == "0000") {
	  	  	dispatch(riskEvaluationPieData(data));
	        console.log("风险测评数据");
	        console.log(data);
	        callBack();
	  	  }else {
          Toast.hide();
          Toast.info(data.code, Util.ToastTime );
	  	  	console.log(data.code);
	  	  }
	  	}, (err) => {
        Toast.hide();
        Toast.info(Util.errorTxt, Util.ToastTime );
	  		console.log("错误信息" + err);
	  	});
	  });
  }
}

//费率计算
export function getBuyFee(data,callBack,callBack2=()=>{}) {
  return function(dispatch, getState) {
    console.log('费率计算入参:',data)
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      Util.get(Util.url+"/superfund/buy/getBuyFee",data,function(result){
        if (result.code=='0000') {
          callBack(result.content)
        }else{
          callBack2(result.message)
          // let toast = Toast.show(result.message, getToastConfPoint( ) );
        }
        console.log(callBack2,result)
      },function(error){
        // let toast = Toast.show( Util.errorTxt, getToastConfPoint( ) );
        console.log('费率计算入参 error')
      })
    }).catch( (err)=>{ console.log(err) } )
  }
}
export function getCondition(data,callBack) {
  return async function(dispatch, getState) {
    let isRealName =getLoginState();
    if (isRealName == "1") {
      callBack(false)
    } else {
      // dispatch(setPayLoading(true))
      getTempInfo("shortToken").then((token) => {
        data.token = token;
        console.log('getCondition:',data)
        Util.get(Util.url+"/superfund/account/hasInvested",data,function(result){
          if (result.code=='0000') {
            console.log(result,'是否有这个基金,true有')
            callBack(result.content.invested)
          }else{
            callBack(false)
          }
        },function(error){
          // dispatch(setPayLoading(false))
          console.log(error)
        })
      }).catch( (err)=>{
        // dispatch(setPayLoading(false))
      });
    };
  }
}
export function getModify(data,callBack) {
  return function(dispatch, getState) {
    console.log('是否需要季度调仓,true需要')
    Util.get(Util.url+"/api/superfund/checkNeedNotice",data,function(result){
      console.log(result,'是否需要季度调仓,true需要')
      if (result.code=='0000') {
        if (result.content) {
          callBack(2)
        }else{
          dispatch(getAdjust(data,callBack))
        }
      }
    },function(error){

    })
  }
}
export function getAdjust(data,callBack) {
  return function(dispatch, getState) {
    Util.get(Util.url+"/api/superfund/checkNeedUpdate",data,function(result){
      console.log(result,'是否可追加投资,true可以')
      if(result.code == "0000"){
        if (result.content.needAdjust) {
          callBack(1)
        } else {
          callBack(3)
        }
        // callBack(result.content);
      }
    },function(error){
      
    })
  }
}

//是否持仓
export function isInvestmentFlag(data, callBack) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      data.token = token;
      Util.get(Util.url+"/superfund/account/hasInvested",data,function(result){
        if(result.code == "0000"){
          if (callBack) {
            callBack(result.content.invested, result.content.riskLevel);
          }
        }else{
          // let toast = Toast.show( result.code, getToastConfPoint( ) );
        }
      },function(error){
        console.log(error)
      })
    })
    .catch( (err)=>{
    });
  }
}
//是否需要调仓(追加投资) 
export function myNeedUpdate(text){
  return {
    type:"NEED_UPDATE",
    text:text
  }
}
export function checkNeedUpdate(data) {
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      dispatch(checkNeedNotice(data))
      Util.get(Util.url+"/api/superfund/checkNeedUpdate",data,function(result){
        if (result.code=='0000') {
          dispatch(myNeedUpdate(result.content.needAdjust))
        }else{

        }
        console.log('追加投资checkNeedUpdate :',result)
      },function(error){
        console.log('checkNeedUpdate error')
      })

    }).catch( (err)=>{ console.log(err) } )
  }
}
//是否需要调仓(季度调仓)
export function myNeedNotice(text){
  return {
    type:"NEED_NOTICE",
    text:text
  }
}
export function checkNeedNotice(data) {
  return function(dispatch, getState) {
    // getTempInfo( 'shortToken' ).then( (d)=>{ 
    //   let newData=data;
    //   newData.token=d;
    //   console.log('checkNeedUpdate:',newData)
      Util.get(Util.url+"/api/superfund/checkNeedNotice",data,function(result){
        if (result.code=='0000') {
          dispatch(myNeedNotice(result.content))
        }else{
        }
        console.log(result,'季度调仓checkNeedNotice')
      },function(error){
        // let toast = Toast.show( Util.errorTxt, getToastConfPoint( ) );
        console.log('checkNeedNotice error')
      })
    // }).catch( (err)=>{ console.log(err) } )
  }
}
let getVal=(property)=>{
    return function(a,b){
        var value1 = a[property];
        var value2 = b[property];
        return value2 - value1;
    }
}
export function getSeasonDetail(data) {
  return function(dispatch, getState) {
    Toast.loading('', 0, () => {});
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      let newData=data;
      newData.token=d;
      console.log('调仓getSeasonDetail入参:',newData)
      Util.get(Util.url+"/api/superfund/getSeasonDetail",newData,function(result){
        if (result.code=='0000') {
          let data1=JSON.parse( JSON.stringify(result.content.previewItemFunds) );
          for (var i = 0; i < data1.length; i++) {
            if (data1[i].srcRegularRate==null) {
              data1.splice(i,1)
              i-=1;
              continue;
            }
            for (var j = i+1; j < data1.length; j++) {
              console.log(i,j)
              if (data1[i].styleTypeName==data1[j].styleTypeName) {
                if (Object.prototype.toString.call(data1[j].srcRegularRate)=="[object Number]") {
                  data1[i].srcRegularRate=data1[i].srcRegularRate+data1[j].srcRegularRate;
                }
                data1.splice(j,1)
                j-=1;
              } 
            }
          }
          data1.sort(getVal('srcRegularRate'))
          result.content.previewItemFundsChart=data1;
          dispatch(mySeasonDetail(result.content))
          Toast.hide()
        }else{
          Toast.info(result.message, Util.ToastTime);
        }
        console.log(result)
      },function(error){
        Toast.hide()
    //     let toast = Toast.show( Util.errorTxt, getToastConfPoint( ) );
        console.log('调仓 error')
    //       dispatch(pageFlag(false));

      })
    }).catch( (err)=>{ Toast.hide() } )
  }
}
//调整组合（追加详情）
export function getAdjustDetail(data,callBack) {
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      Util.get(Util.url+"/api/superfund/getAdjustDetail",data,function(result){
        if (result.code=='0000') {
          let data1=JSON.parse( JSON.stringify(result.content.previewItemFunds) );
          for (var i = 0; i < data1.length; i++) {
            if (data1[i].srcRegularRate==null) {
              data1.splice(i,1)
              i-=1;
              continue;
            }
            for (var j = i+1; j < data1.length; j++) {
              console.log(i,j)
              if (data1[i].styleTypeName==data1[j].styleTypeName) {
                if (Object.prototype.toString.call(data1[j].srcRegularRate)=="[object Number]") {
                  data1[i].srcRegularRate=data1[i].srcRegularRate+data1[j].srcRegularRate;
                }
                data1.splice(j,1)
                j-=1;
              } 
            }
          }
          data1.sort(getVal('srcRegularRate'))
          result.content.previewItemFundsChart=data1;
          dispatch(mySeasonDetail(result.content))
        }else{
          callBack(result)
          Toast.info(result.message, Util.ToastTime );
        }
        console.log(result)
      },function(error){
        console.log('getAdjustDetail error')
      })
    }).catch( (err)=>{ } )
  }
}

//季度调仓
export function mySeasonDetail(text){
  return {
    type:"SEASON_DETAIL",
    text:text
  }
}
/*组合已投资详情*/
export function InvestStop(text){
  return {
    type:"INVEST_STOP",
    text:text
  }
}


/*智投组合未投详情*/
export function investNotCombination(text){
  return {
    type:"INVES_NOT_COMBINATION",
    text:text
  }
}

// 智投产品交易规则和费率
export const getJiaoYis = (data,sucBack) => {
  return async (dispatch, getState) => {
    const getFundBack = async (succ) => {
      if(succ.code == "0000"){
      sucBack(succ.content)
      }else{
        Toast.info(succ.message);
      }
    };
    const errFundBack = (err) => {
      Toast.info( err );
    }
      Util.get(Util.url+"/api/v1/superfund/trade/rule/getSuperFundTradeRule?",{superFundCode:data},getFundBack,errFundBack)
  }
}

//获取止盈 非止盈 智投开放状态
export function verifyActivityBool (params,sucBack) {
  return async function(dispatch, getState){
    const token = await getTempInfo("shortToken");
    Util.get(Util.url+"/api/v1/superfund/trade/rule/getSuperFundTradeOpenStatus?",{superFundCode:params.superFundCode,stopProfit:params.stopProfit,token:token},function(result){
      console.log(result);
      if (result.code=='0000') {
        sucBack(result.content)
      }
    },function(error){
      console.log(error);
      Toast.info( Util.errorTxt, ToastTime);
    });
  }
}

//获取止盈 非止盈 智投开放状态（已投）
export function verifyActivityBoolHaveCast (params,sucBack) {
  return async function(dispatch, getState){
    const token = await getTempInfo("shortToken");
    params.token=token;
    Util.get(Util.url+"/api/v1/superfund/trade/rule/getSuperFundTradeOpenStatus4Hold",params,function(result){
      console.log(result);
      if (result.code=='0000') {
        sucBack(result.content)
      }
    },function(error){
      console.log(error);
      Toast.info( Util.errorTxt, ToastTime);
    });
  }
}

/*组合表现折线图*/
export function QueryInCome(text){
  return {
    type:"QUERY_INCOME_Line",
    text:text
  }
}



/* 操作记录明细, http://10.16.0.240/hxcfapp_dev/api/superfund/queryTradeRecords */
export function QueryTradeRecords(text){
  return {
    type:"QUERY_TRADE_RECORDS",
    text:text
  }
}

export function getQueryTradeRecords(data,callback,_this) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      Toast.loading('', 0, () => {});
      data.token = token;
      Util.get(Util.url+"/api/superfund/queryTradeRecords",data,function(data){
        Toast.hide();
        if(data.code == "0000"){
          dispatch(QueryTradeRecords(data.content));
          callback(data.content)
          console.log(data.content,"操作记录明细")
        }else{
          Toast.hide();
          //let toast = Toast.show(data.message, getToastConfPoint( ) );
        }
        // if(trJson.code === "0000"){
        //   dispatch(QueryTradeRecords(trJson.content));
        //   callback(trJson.content)
        // }
      },function(error){
        Toast.hide()
        console.log(error,"错误信息")
        //let toast = Toast.show("网络异常，请检查您的网络", getToastConfPoint( ) );

      })
    }).catch( (err)=>{
      Toast.hide()
      //let toast = Toast.show(Util.errorTxt, getToastConfPoint( ) );

    });

  }
}

let trJson = {"code":"0000","message":null,"content":[{"applicationAmount":1000.0,"businessState":"2090","businessStateName":"成功","businessTime":"2017-07-12 17:13:30","businessType":"T522","businessTypeName":"华夏智投银行卡申购","fundCode":"SF1011","fundName":"常青藤大学组合","taConfirmStateName":"成功","tradeAccountNo":"20000000629","tradeRequestId":"4017071200146009"},{"applicationAmount":1000.0,"businessState":"2090","businessStateName":"成功","businessTime":"2017-07-12 17:12:44","businessType":"T522","businessTypeName":"华夏智投银行卡申购","fundCode":"SF1011","fundName":"常青藤大学组合","taConfirmStateName":"成功","tradeAccountNo":"20000000629","tradeRequestId":"4017071200146008"},{"applicationAmount":998.96,"businessState":"2090","businessStateName":"部分成功","businessTime":"2017-07-12 15:32:17","businessType":"T024","businessTypeName":"赎回","fundCode":"SF1005","fundName":"锐意进取组合","taConfirmStateName":"部分确认","tradeAccountNo":"20000000629","tradeRequestId":"4017071200145992"},{"applicationAmount":1000.0,"businessState":"2090","businessStateName":"成功","businessTime":"2017-07-10 08:45:28","businessType":"T522","businessTypeName":"华夏智投银行卡申购","fundCode":"SF1005","fundName":"锐意进取组合","taConfirmStateName":"成功","tradeAccountNo":"20000000629","tradeRequestId":"4017071000143419"},{"applicationAmount":1000.0,"businessState":"2060","businessStateName":"失败","businessTime":"2017-07-06 14:57:37","businessType":"T522","businessTypeName":"华夏智投银行卡申购","fundCode":"SF1006","fundName":"60后智享财富组合","taConfirmStateName":"失败","tradeAccountNo":"20000000629","tradeRequestId":"4017070600140073"}]}

/*历史收益列表*/
export const  historyIncomeList = (text)=>{
  return {
    type: 'HISTORY_ICOME_LIST',
    text
  }
}
export function getHistoryIcomeList(data,callback,_this){
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      data.token = token;
      let fundCode =  data.fundCode;
      let url = ""
      if(Util.superFundCodeArr.indexOf(fundCode)){
        url = Util.url+"/superfund/myAsset/superFundIncomeDetailQuery"
      }else if(fundCode === "SF1000"){
        data.fundCode = "";
        url = Util.url+"/superfund/myAsset/superFundIncomeDetailQuery"
      }else{
        url = Util.url+"/api/myAsset/incomeDetailQuery";
      }
      Util.get(url,data,function(data){
        if(data.code == "0000"){
          dispatch(historyIncomeList(data.content));
          console.log(true,data,"历史收益列表")
          callback(data.content);
        }else{
          Toast.info(data.message, ToastTime);
          _this.setState({
            loadingFlag:false,
          })
        }
      },function(error){
        console.log(error)
        Toast.info(Util.errorTxt, ToastTime);
        _this.setState({
          loadingFlag:false,
        })
      })
    }).catch( (err)=>{
      Toast.info(Util.errorTxt, ToastTime);
    });
  }
}

export function getHistoryIcomeListSuper(data,callback,_this){
  return function(dispatch, getState) {
    Toast.loading('', 0, () => {});
    getTempInfo("shortToken").then((token) => {
      data.token = token;
      Util.get(Util.url+"/superfund/myAsset/superFundIncomeDetailQuery",data,function(data){
       
        if(data.code == "0000"){
           Toast.hide()
          dispatch(historyIncomeList(data.content));
          console.log(data,"超级基金历史收益列表")
          callback(data.content);
        }else{
          Toast.info(data.message, ToastTime);
          _this.setState({
            loadingFlag:false,
          })
        }
      },function(error){
        console.log(error)
        Toast.info(Util.errorTxt, ToastTime);
        _this.setState({
          loadingFlag:false,
        })
      })
    }).catch( (err)=>{
      Toast.info(Util.errorTxt, ToastTime);
    });
  }
}




/*调仓记录*/ 
export function HistoryAdjustAction(text) {
  return {
    type: "HISTORY_DETAIL",
    text: text
  }
}

export function getHistoryAdjust(data,callBack,_this) {
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      Util.get(Util.url+"/api/superfund/getHistoryAdjustDetail",data,function(result){
        if (result.code=='0000') {
         dispatch(HistoryAdjustAction(result.content))
         callBack(result.content)
        }else{
          Toast.info(result.message, ToastTime);
        }
 
      },function(error){
        console.log(error)
        Toast.info(Util.errorTxt, ToastTime);
      })
    }).catch( (err)=>{ console.log(err) } )
  }
}
/* 查询智投组合当前成分基金*/
export function getCurrentAdjustDetail(data,callBack,_this) {
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      Util.get(Util.url+"/api/superfund/getCurrentAdjustDetail",data,function(result){
        if (result.code=='0000') {
         callBack(result.content)
        }else{
          Toast.info(result.message, ToastTime);
        }
 
      },function(error){
        Toast.info(Util.errorTxt, ToastTime);
      })
    }).catch( (err)=>{ console.log(err) } )
  }
}

//智投小常乐详情
export function SuperFoundDetailXCL(text) {
  return {
    type: "SUPERFUND_DETAIL_XCL",
    text: text
  }
}
//小常乐详情配置详情 新
export function getSuperFoundDetail(data) {
  return function(dispatch, getState) {
      Util.get(Util.url+"/api/query/getSuperFoundDetail",{fundCode:data},function(result){
        if (result.code=='0000') {
          dispatch(SuperFoundDetailXCL(result.content.superFundDetail))
          // sucBack(result.content.superFundDetail)
        }else{
          
        }
        console.log(result,"小常乐详情接口")
      },function(error){
        Toast.info( Util.errorTxt, ToastTime);
        console.log(error)
      })
  }
}

/*获取所有交易基金的代码和名称*/
export const  historyFundCodeAndName = (text)=>{
  return {
    type: 'HISTORY_FUNDCODE_NAME_LIST',
    text
  }
}
export function getHistoryFundCodeAndName(data,_this,callback){
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      data.token = token;
      Util.get(Util.url+"/api/myAsset/incomeFundCodeAndNameQueryRequest",data,function(data){
        if(data.code == "0000"){
          let newData=data.content.filter((item)=>{
            return item.fundCode.startsWith('SF')
          })
          data.content=newData;
          dispatch(historyFundCodeAndName(newData));
          if(callback){
            callback(data.content)
          }
        }else{
          Toast.info(data.message, ToastTime);
        }
      },function(error){
        if(callback){
            callback(null)
          }
        Toast.info(Util.errorTxt, ToastTime);
      })
    }).catch( (err)=>{
      
    });
  }
}

/*获取历史交易确认列表*/
export const  historyTradeList = (text)=>{
  return {
    type: 'HISTORY_TRADE_LIST',
    text
  }
}
export function getHistoryTradeList(data,callback,_this){
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      data.token = token;
      Util.get(Util.url+"/api/myAsset/tradeList",data,function(data){
        if(data.code == "0000"){
          dispatch(historyTradeList(data.content));
          console.log(true,data,"获取历史交易确认列表")
          callback(data.content);
        }else{
          _this.setState({
            loadingFlag: false
          })
          Toast.info(data.message, ToastTime);
        }
      },function(error){
        _this.setState({
            loadingFlag: false
        })
        Toast.info(Util.errorTxt, ToastTime);
      })
    }).catch( (err)=>{
      _this.setState({
        loadingFlag: false
      })
    });
  }
}

/*获取分红列表*/
export const  findDividendList = (text)=>{
  return {
    type: 'FIND_DIVIDEND_LIST',
    text
  }
}
export function getHistoryFindDividend(data,callback,_this){
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      data.token = token;
      Util.get(Util.url+"/api/myAsset/findDividendHistory",data,function(data){
        if(data.code == "0000"){
          dispatch(findDividendList(data.content));
          console.log(true,data,"获取分红列表")
          callback(data.content);
        }else{
          _this.setState({
            loadingFlag: false
          })
          Toast.info(data.message, ToastTime);
        }
      },function(error){
        console.log(error)
        _this.setState({
            loadingFlag: false
        })
        Toast.info(Util.errorTxt, ToastTime);
      })
    }).catch( (err)=>{
      _this.setState({
        loadingFlag: false
      })
    });
  }
}





//实名认证职业列表
export function userJob(text) {
  return {
    type: "USER_JOB",
    text: text
  }
}
//实名认证城市列表
export function provinceCity(text) {
  return {
    type: "PROVINCE_CITY",
    text: text
  }
}

//获取实名认证职业列表
export function getUserJob() {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      Util.get(Util.url + "/api/account/getCareers", {}, (data) => {
        if(data.code == "0000") {
          dispatch(userJob(data.content));
          console.log("职业列表");
          console.log(data.content);
        }else {
          console.log(data.code);
          Toast.info(data.code, 2);
        }
      }, (err) => {
        Toast.info("错误信息" + err, 2);
        console.log("错误信息" + err);
      });
    });
  }
}

//获取实名认证城市列表
export function getProvinceCity(callback, errback) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      Util.get(Util.url + "/api/account/getProvinceAndCity", {}, (data) => {
        if(data.code == "0000") {
          if(callback) {
            callback(data.content);
          }
          dispatch(provinceCity(data.content));
          console.log("城市列表");
          console.log(data);
          Toast.hide();
        }else {
          if(errback) {
            errback();
          }
          console.log(data.code);
          Toast.hide();
          Toast.info(data.code, 2);
        }
      }, (err) => {
        if(errback) {
          errback();
        }
        console.log("错误信息" + err);
        Toast.hide();
        Toast.info("错误信息" + err, 2);
      });
    });
  }
}

//银行卡类型
export function bankType(text) {
  return {
    type: "BANK_TYPE",
    text: text
  }
}

//银行卡列表
export function bankList(text) {
  return {
    type: "BANK_LIST",
    text: text
  }
}

//获取银行列表
export function getBankList(params) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      let obj = {};
      obj.token = "";
      Util.get(Util.url + "/api/realnameauth/getBankCardList", obj, (data) => {
        if(data.code == "0000") {
          dispatch(bankList(data));
          if(params != undefined) {
            for(let i = 0; i < data.content.length; i++) {
              if(params.content.bankCode == data.content[i].bankCode) {
                dispatch(bankType({content:{cardName: data.content[i].paymentChannelName, bankCode: data.content[i].bankCode}}));
                break;
              }else {
                if(i == data.content.length - 1) {
                  dispatch(bankType({content:{
                    cardName: null,
                    bankCode: null
                  }}));
                  break;
                }
              }
            }
          }
          console.log("银行列表");
          console.log(data);
        }else {
          console.log(data.code); 
          Toast.info(data.code, 2);
        }
      }, (err) => {
        console.log("错误信息" + err);
        Toast.info("错误信息" + err, 2);
      });
    });
  }
}

//获取卡类型
export function getBankType(params) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      params.token = token;
      Util.get(Util.url + "/api/realnameauth/getBankName", params, (data) => {
        if(data.code == "0000") {
          if(data.content.bankCode == "" || data.content.bankCode == null) {
            dispatch(bankType({content:{cardName: null, bankCode: null}}));
          }else {
            dispatch(getBankList(data));
          }
          console.log("卡类型");
          console.log(data);
        }else {
          dispatch(bankType({content:{cardName: null, bankCode: null}}));
          console.log(data.code);
          Toast.info(data.code, 2);
        }
      }, (err) => {
        console.log("错误信息" + err);
        Toast.info("错误信息" + err, 2);
      });
    });
  }
}

//获取流水号
export function checkNumber(text) {
  return {
    type: "CHECK_NUMBER",
    text: text
  }
}

export function dianji(text) {
  return {
    type: "DIANJI",
    text: text
  }
}
//鉴权确认
export function checkSuccessData(text) {
  return {
    type: "CHECK_SUCCESS_DATA",
    text: text
  }
}

//鉴权申请
export function getCheckNumber(params,errBack) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      Util.postNew(Util.url + "/api/v1/bankCard/bankCardAuthApply?token="+token, params, (data) => {
        if(data.code == "0000") {
          dispatch(checkNumber(data));
          console.log("鉴权申请");
          console.log(data);
          Toast.hide();
        }else {
          console.log(data.code);
          Toast.info(data.code, 2);
          Toast.hide();
          errBack();
        }
      }, (err) => {
        console.log("错误信息" + err);
        Toast.info("错误信息" + err, 2);
        Toast.hide();
        errBack();
      });
    });
  }
}

//鉴权确认
export function getCheckSuccessData(params, callBack) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      params.token = token;
      Util.get(Util.url + "/api/realnameauth/authConfirm", params, (data) => {
        if(data.code == "0000") {
          dispatch(checkSuccessData(data));
          console.log("鉴权确认");
          console.log(data);
          callBack();
          Toast.hide();
        }else {
          console.log(data.code);
          Toast.hide();
          Toast.info(data.code, 2);
        }
      }, (err) => {
        console.log("错误信息" + err);
        Toast.hide();
        Toast.info("错误信息" + err, 2);
      });
    });
  }
}


/*所有的国家列表*/
export const  AllCountry = (text)=>{
	return {
		type: 'ALL_COUNTRY',
		text
	}
}

export function getAllCountry(callback,_this){
  return function(dispatch, getState) {
      let data = {}
      Util.get(Util.url+"/api/account/getAllCountry",data,function(data){
        if(data.code == "0000"){
          dispatch(AllCountry(data.content));
          callback(data.content);
        }else{

        }
      },function(error){

      })
  }
}


//实名认证创建交易账号
export function certifcationSuccess(text) {
  return {
    type: "CERTIFCATION_SUCCESS",
    text: text
  }
}
//实名认证创建交易账号
export function getCertifcationSuccess(thisO,data,callBack,savePicFun) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      if(token == null || token == "9999") {
        token = "";
      }
      console.log(data,"转入的参数");
      data.token = token;
      data.clientType=Util.return_Clinet_Type();
      let allParams = data;
      Util.get(Util.url+"/api/realnameauth/realNameAuth",data,function(data){
        if(data.code == "0000"){
          let TM=new Date();
          if(savePicFun) {
            savePicFun(data.content.shortToken, allParams);
          }
          setStorage('currentUserInfo', data.content);
          setStorage('tokenTimeLong',TM.getTime()+window.tokenTimeLong);
          setStorage('tokenTimeshort',TM.getTime()+window.tokenTimeshort);
          setStorage('loginInfo-shortToken', data.content.shortToken);
          setStorage('loginInfo-longToken', data.content.longToken);
          setStorage('loginState', '2');
          dispatch(certifcationSuccess(data));
          dispatch(getUserInfoList());
          console.log(data,"实名认证成功回调");
          if(callBack){
            callBack();
          }
          console.log("实名认证创建交易账号");
          console.log(data);
        }else{
          console.log(data.code);
          Toast.info(data.message, ToastTime);
        }
      },function(err){
        console.log("错误信息" + err);
        Toast.info('网络异常，请检查您的网络', ToastTime);
      })

    });
  }
}


//按照证件类型登录
export const loginHXAssets = (loginParam, succallback, errcallback)=>{
    return (dispatch, getState)=>{
      Toast.loading('', 0, () => {});
      const successCallback = async (succ)=>{
          Toast.hide()
          console.log(succ);
          if(succ && succ.code === '0000'){
            let TM=new Date()
            setStorage('tokenTimeLong',TM.getTime()+window.tokenTimeLong);
            setStorage('tokenTimeshort',TM.getTime()+window.tokenTimeshort);
            let userInfo=succ.content
            userInfo.isRealName = succ.content.tradeAccountNo ? true : false
            if(succ.content.name != undefined)
              userInfo = mergeObjectEasy(userInfo, {name: succ.content.name});
            if(succ.content.nickName != undefined)
              userInfo = mergeObjectEasy(userInfo, {nickName: succ.content.nickName});
            if(succ.content.tradeAccountNo != undefined)
              userInfo = mergeObjectEasy(userInfo, {tradeAccountNo: succ.content.tradeAccountNo});
            console.log('华夏财富userInfo1', userInfo);
            let user = await getTempInfo('userList-'+userInfo.userId);
            if(user!=9999){
              userInfo = mergeObjectEasy(user, userInfo);
            }
            console.log('华夏财富userInfo2', userInfo);
            if(succ.content.hasCwimAccount == true ){
              if (succ.content.tradeAccountNo) {
                setStorage('loginState', '2');
              } else {
                setStorage('loginState', '1');
              }
              setStorage('userList-' + userInfo.userId, userInfo);
              setStorage('currentUserInfo', userInfo);
              setStorage('loginInfo-shortToken', succ.content.shortToken);
              setStorage('loginInfo-longToken', succ.content.longToken);
              dispatch(isLogin(true));
            //   // dispatch(isRealName(userInfo.isRealName));
              dispatch(getUserInfoList(() => {
                succallback(succ.content);
              }));
            }else{
              setStorage('loginState', '3');
              setStorage('userList-' + userInfo.userId, userInfo);
              setStorage('currentUserInfo', userInfo);
              setStorage('loginInfo-shortToken', succ.content.shortToken);
              setStorage('loginInfo-longToken', succ.content.longToken);
              dispatch(syncAccountName(succ.content.name));
              dispatch(syncAccountLoginType(succ.content.certType));
              dispatch(syncAccountLoginNo(succ.content.certNo));
              succallback(succ.content);
            }
          }else{
            console.log('后台返回数据有误!');
            errcallback(succ.message);
          }
      
      };
      const errorCallback = (err)=>{
          Toast.hide()
        
        console.log(err);
          // errcallback(Util.errorTxt);
      };

      Util.post(Util.url + '/api/account/certLogin', loginParam, successCallback, errorCallback);

    }
}

/*智投重构交易记录列表*///包含了分红详情的数据
export function ztcgjiaoyijilu(data,callbackData,_this) {
  return function(dispatch, getState) {
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token=d;
      Util.get(Util.url+"/api/v1/superfund/tradeRecord/getTradeRecordList",data,function(result){
        if (result.content==null) {
        } else {
          callbackData(result.content)
        }
        if(_this){
          _this.setState({
            loadingFlag:false
          })
        }
      },function(error){
        if(_this){
          _this.setState({
            loadingFlag:false
          })
        }

      })
    }).catch( (err)=>{
      if(_this){
        _this.setState({
          loadingFlag:false
        })
      }

    })
  }
}

/*智投重构交易记录详情*///不包含分红详情的数据
export function ztcgjiaoyijiluxiangqing(data,callbackData,_this) {
return function(dispatch, getState) {
  getTempInfo( 'shortToken' ).then( (d)=>{ 
    data.token = d;
    Util.get(Util.url+"/api/v1/superfund/tradeRecord/getTradeRecordDetail",data,function(result){
      if (result.content==null) {
      } else {
        if(result && result.content) {
          callbackData(result.content.superFundTradeRecordDetails, result.content.cancel);
        }else {
          callbackData([], result.content.cancel);
        }
      }
      if(_this){
        _this.setState({
          loadingFlag:false
        })
      }
    },function(error){
      if(_this){
        _this.setState({
          loadingFlag:false
        })
      }

    })
  }).catch( (err)=>{
    if(_this){
      _this.setState({
        loadingFlag:false
      })
    }

  })
}
}

/*智投重构交易记录服务费*/
export function ztcgfuwufei(data,callbackData,_this) {
return function(dispatch, getState) {
  //dispatch(pageFlag(true))
  getTempInfo( 'shortToken' ).then( (d)=>{ 
    data.token = d;
    Util.get(Util.url+"/api/v1/superfund/tradeRecord/getSuperFundUserManageFee",data,function(result){
      if (result.content==null) {
      } else {
        callbackData(result.content)
      }
      if(_this){
        _this.setState({
          loadingFlag:false
        })
      }
    },function(error){
      if(_this){
        _this.setState({
          loadingFlag:false
        })
      }

    })
  }).catch( (err)=>{
    if(_this){
      _this.setState({
        loadingFlag:false
      })
    }

  })
}
}

/*智投重构交易记录服务费明细*/
export function ztcgfuwufeimingxi(data,callbackData,_this) {
return function(dispatch, getState) {
  //dispatch(pageFlag(true))
  getTempInfo( 'shortToken' ).then( (d)=>{ 
    data.token = d;
    Util.get(Util.url+"/api/v1/superfund/tradeRecord/getSuperFundUserManageFeeDetail",data,function(result){
      if (result.content==null) {
      } else {
        callbackData(result.content)
      }
      if(_this){
        _this.setState({
          loadingFlag:false
        })
      }
    },function(error){
      if(_this){
        _this.setState({
          loadingFlag:false
        })
      }

    })
  }).catch( (err)=>{
    if(_this){
      _this.setState({
        loadingFlag:false
      })
    }

  })
}
}


//养老教育储备金
export function yljycbMoney(text) {
  return {
    type: "YLJYCB_MONEY",
    text: text
  }
}
//预期养老教育金
export function yqyljyMoney(text) {
  return {
    type: "YQYLJY_MONEY",
    text: text
  }
}
//养老教育年龄
export function yljyAge(text) {
  return {
    type: "YLJY_AGE",
    text: text
  }
}
//养老退休年龄
export function ylOutAge(text) {
  return {
    type: "YL_OUTAGE",
    text: text
  }
}
//预期养老教育金2
export function yqyljySliderVal(text) {
  return {
    type: "YQYLJY_SLIDER_VAL",
    text: text
  }
}
//养老教育投资方案
export function yljyPlan(text) {
  return {
    type: "YLJY_PLAN",
    text: text
  }
}
//养老教育指数
export function yljyNum(text) {
  return {
    type: "YLJY_NUM",
    text: text
  }
}
//养老教育投入金额
export function yljyAllMoney(text) {
  return {
    type: "YLJY_ALL_MONEY",
    text: text
  }
}
//养老教育金额图表
export function yljyLineData(text) {
  return {
    type: "YLJY_LINE_DATA",
    text: text
  }
}
//教育学校类型
export function jySchoolType(text) {
  return {
    type: "JY_SCHOOL_TYPE",
    text: text
  }
}
//初始化养老第一页数据
export function clearYlOne() {
  return function(dispatch, getState) {
    dispatch(yljycbMoney("0"));
    dispatch(yqyljyMoney(5000));
    dispatch(yqyljySliderVal(5000));
    dispatch(yljyAge("35"));
    dispatch(ylOutAge("65"));
  }
}
//初始化教育第一页数据
export function clearJyOne(school) {
  return function(dispatch, getState) {
    if(school == "初中") {
      dispatch(yljycbMoney("0"));
      // dispatch(yqyljyMoney(20000));
      // dispatch(yqyljySliderVal(20000));
      dispatch(yljyAge([5]));
    }else if(school == "高中") {
      dispatch(yljycbMoney("0"));
      // dispatch(yqyljyMoney(20000));
      // dispatch(yqyljySliderVal(20000));
      dispatch(yljyAge([6]));
    }else if(school == "大学") {
      dispatch(yljycbMoney("0"));
      // dispatch(yqyljyMoney(20000));
      // dispatch(yqyljySliderVal(20000));
      dispatch(yljyAge([8]));
    }
    dispatch(jySchoolType("国内院校"));
    dispatch(yqyljyMoney(20000));
    dispatch(yqyljySliderVal(20000));
  }
}
//初始化养老教育计划页数据
export function clearYlJyEnd() {
  return function(dispatch, getState) {
    dispatch(yljyPlan("每月投资方案"));
    dispatch(yljyNum(["沪深300，年化8%"]));
    dispatch(yljyAllMoney(null));
    dispatch(yljyLineData(null));
  }
}

//实名认证持卡人
export function smrzCardPerson(text) {
  return {
    type: "SMRZ_CARD_PERSON",
    text: text
  }
}
//实名认证身份证号
export function smrzPersonNumber(text) {
  return {
    type: "SMRZ_PERSON_NUMBER",
    text: text
  }
}
//实名认证地址
export function smrzAddress(text) {
  return {
    type: "SMRZ_ADDRESS",
    text: text
  }
}
//实名认证控制人地址
export function smrzkzrAddress(text) {
  return {
    type: "SMRZ_KZRADDRESS",
    text: text
  }
}
//实名认证受益人地址
export function smrzsyrAddress(text) {
  return {
    type: "SMRZ_SYRADDRESS",
    text: text
  }
}
//实名认证控制人邮政编码
export function smrzkzrBianma(text) {
  return {
    type: "SMRZ_KZRBIANMA",
    text: text
  }
}
//实名认证受益人邮政编码
export function smrzsyrBianma(text) {
  return {
    type: "SMRZ_SYRBIANMA",
    text: text
  }
}

//实名认证控制人电子邮箱
export function smrzkzrYoux(text) {
  return {
    type: "SMRZ_KZRYOUX",
    text: text
  }
}
//实名认证受益人电子邮箱
export function smrzsyrYoux(text) {
  return {
    type: "SMRZ_SYRYOUX",
    text: text
  }
}
//实名认证职业
export function smrzJob(text) {
  return {
    type: "SMRZ_JOB",
    text: text
  }
}
//实名认证控制人职业
export function smrzkzrJob(text) {
  return {
    type: "SMRZ_KZRJOB",
    text: text
  }
}
//实名认证受益人职业
export function smrzsyrJob(text) {
  return {
    type: "SMRZ_SYRJOB",
    text: text
  }
}
//实名认证职业代码
export function smrzCareerCode(text) {
  return {
    type: "SMRZ_CAREERCODE",
    text: text
  }
}
//实名认证控制人职业代码
export function smrzCareerkzrCode(text) {
  return {
    type: "SMRZ_CAREERKZRCODE",
    text: text
  }
}
//实名认证受益人职业代码
export function smrzCareersyrCode(text) {
  return {
    type: "SMRZ_CAREERSYRCODE",
    text: text
  }
}
//实名认证年收入
export function smrznsrcode(text) {
  return {
    type: "SMRZ_NSRCODE",
    text: text
  }
}
//实名认证具体年收入
export function smrznJtsrcode(text) {
  return {
    type: "SMRZ_JTNSRCODE",
    text: text
  }
}
//实名认证城市
export function smrzCity(text) {
  return {
    type: "SMRZ_CITY",
    text: text
  }
}
//实名认控制人城市
export function smrzkzrCityc(text) {
  return {
    type: "SMRZ_KZRCITY",
    text: text
  }
}
//实名认受益人城市
export function smrzsyrCityc(text) {
  return {
    type: "SMRZ_SYRCITY",
    text: text
  }
}
//实名认证控制人
export function smrzBeneficontro(text) {
  return {
    type: "SMRZ_BENEFCONTRO",
    text: text
  }
}
//实名认证受益人
export function smrzBeneficiaries(text) {
  return {
    type: "SMRZ_BENEFICIARIES",
    text: text
  }
}
//实名认证控制人姓名
export function smrzBeneficontroName(text) {
  return {
    type: "SMRZ_BENEFCONTRO_NAME",
    text: text
  }
}
//实名认证控制人证件有效期
export function smrzBeneficontroZjyxq(text) {
  return {
    type: "SMRZ_BENEFCONTRO_ZJYXQ",
    text: text
  }
}
//实名认证主账户证件有效期
export function zzhZjyxq(text) {
  return {
    type: "ZZH_ZJYXQ",
    text: text
  }
}
//实名认证受益人证件有效期
export function smrzBeneficiariesZjyxq(text) {
  return {
    type: "SMRZ_BENEFICIARIES_ZJYXQ",
    text: text
  }
}
//实名认证控制人证件照片
export function smrzBeneficontroZjzq(text) {
  return {
    type: "SMRZ_BENEFCONTRO_ZJZQ",
    text: text
  }
}
//实名认证受益人证件照片
export function smrzBeneficiariesZjzq(text) {
  return {
    type: "SMRZ_BENEFICIARIES_ZJZQ",
    text: text
  }
}
//实名认证控制人性别
export function smrzkzrXbcode(text) {
  return {
    type: "SMRZ_BENEFCONTRO_XBCODE",
    text: text
  }
}
//实名认证控受益人性别
export function smrzsyrXbcode(text) {
  return {
    type: "SMRZ_BENEFICIARIES_XBCODE",
    text: text
  }
}
//实名认证控制人出生日期
export function smrzBeneficontroCsrq(text) {
  return {
    type: "SMRZ_BENEFICIARIES_CSRQ",
    text: text
  }
}
//实名认证受益人出生日期
export function smrzBeneficiariesCsrq(text) {
  return {
    type: "SMRZ_BENEFCONTRO_CSRQ",
    text: text
  }
}
//实名认证控制人手机号
export function smrzBeneficontroKzrNo(text) {
  return {
    type: "SMRZ_BENEFCONTRO_KZRNO",
    text: text
  }
}
//实名认证受益人手机号
export function smrzBeneficontroSyrNo(text) {
  return {
    type: "SMRZ_BENEFICIARIES_SYRNO",
    text: text
  }
}
//实名认证受益人姓名
export function smrzBeneficiariesName(text) {
  return {
    type: "SMRZ_BENEFICIARIES_NAME",
    text: text
  }
}
//实名认证回调
export function huiDiao(text) {
  return {
    type: "HUIDIAO",
    text: text
  }
}
//实名认证控制人证件类型
export function smrzBeneficontroType(text) {
  return {
    type: "SMRZ_BENEFCONTRO_TYPE",
    text: text
  }
}
//实名认证受益人证件类型
export function smrzBeneficiariesType(text) {
  return {
    type: "SMRZ_BENEFICIARIES_TYPE",
    text: text
  }
}
//实名认证控制人证件号
export function smrzBeneficontroNo(text) {
  return {
    type: "SMRZ_BENEFCONTRO_NO",
    text: text
  }
}
//实名认证受益人证件号
export function smrzBeneficiariesNo(text) {
  return {
    type: "SMRZ_BENEFICIARIES_NO",
    text: text
  }
}
//实名认证组织
export function smrzGjzz(text) {
  return {
    type: "SMRZ_GJZZ",
    text: text
  }
}
//实名认证银行卡号
export function smrzCardNumber(text) {
  return {
    type: "SMRZ_CARD_NUMBER",
    text: text
  }
}
//实名认证修改手机号
export function smrzUpdatePhoneNo(text) {
  return {
    type: "SMRZ_UPDATE_PHONE_NO",
    text: text
  }
}
//实名认证同意项
export function smrzAgreeItemFlag(text) {
  return {
    type: "SMRZ_AGREE_ITEM_FLAG",
    text: text
  }
}
//实名认证验证码
export function smrzCheckCard(text) {
  return {
    type: "SMRZ_CHECK_CARD",
    text: text
  }
}
//实名认获取证验证码显示文字
export function smrzCheckCardText(text) {
  return {
    type: "SMRZ_CHECK_CARD_TEXT",
    text: text
  }
}
//实名认证验证码状态
export function smrzCheckCardFlag(text) {
  return {
    type: "SMRZ_CHECK_CARD_FLAG",
    text: text
  }
}
//实名认证交易密码
export function smrzPassWord(text) {
  return {
    type: "SMRZ_PASS_WORD",
    text: text
  }
}
//实名认证确认交易密码
export function smrzPassWordAgain(text) {
  return {
    type: "SMRZ_PASS_WORD_AGAIN",
    text: text
  }
}
//初始化实名认证交易密码
export function clearSmrzPassWord() {
  return function(dispatch, getState) {
    dispatch(smrzPassWord(""));
    dispatch(smrzPassWordAgain(""));
  }
}
//初始化实名认证获取验证码页
export function clearSmrzCheckCard() {
  return function(dispatch, getState) {
    dispatch(smrzCheckCard(""));
    dispatch(smrzCheckCardText("获取验证码"));
    dispatch(smrzCheckCardFlag(false));
  }
}
//初始化实名认证填卡页
export function clearSmrzThird(num) {
  return function(dispatch, getState) {
    dispatch(smrzUpdatePhoneNo(num));
    dispatch(smrzAgreeItemFlag(false));
  }
}
//初始化实名认证第一页
export function clearSmrzOne() {
  return function(dispatch, getState) {
    dispatch(smrzCardPerson(""));
    dispatch(smrzPersonNumber(""));
    dispatch(smrzAddress(""));
    dispatch(smrzkzrAddress(""));
    dispatch(smrzsyrAddress(""));
    dispatch(smrzkzrBianma(""));
    dispatch(smrzsyrBianma(""));
    dispatch(smrzkzrYoux(""));
    dispatch(smrzsyrYoux(""));
    dispatch(smrzJob([""]));
    dispatch(smrzkzrJob([""]));
    dispatch(smrzsyrJob([""]));
    dispatch(smrzCareerCode(""));
    dispatch(smrzCareerkzrCode(""));
    dispatch(smrzCareersyrCode(""));
    dispatch(smrznJtsrcode(""));
    dispatch(smrznsrcode(""));
    dispatch(smrzCity(["11", "1101"]));
    dispatch(smrzkzrCityc(["11", "1101"]));
    dispatch(smrzsyrCityc(["11", "1101"]));
    dispatch(smrzBeneficiaries(["本人"]));
    dispatch(smrzBeneficiariesName(""));
    dispatch(smrzBeneficiariesType([""]));
    dispatch(smrzBeneficiariesNo(""));
    dispatch(smrzBeneficontro(["本人"]));
    dispatch(smrzBeneficontroName(""));
    dispatch(smrzBeneficontroZjyxq(""));
    dispatch(zzhZjyxq(""));
    dispatch(smrzBeneficiariesZjyxq(""));
    dispatch(smrzBeneficontroZjzq(""));
    dispatch(smrzBeneficiariesZjzq(""));
    dispatch(smrzkzrXbcode(""));
    dispatch(smrzsyrXbcode(""));
    dispatch(smrzBeneficontroCsrq(""));
    dispatch(smrzBeneficiariesCsrq(""));
    dispatch(smrzBeneficontroKzrNo(""));
    dispatch(smrzBeneficontroSyrNo(""));
    dispatch(smrzBeneficontroType([""]));
    dispatch(smrzBeneficontroNo(""));
    dispatch(smrzGjzz(["否"]));
  }
}
//智投规划状态
export function isExpiredByInvestment(params, callBack) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      params.token = token;
      Util.post(Util.url + "/api/v1/superfund/kyc/isExpired", params, (data) => {
        if(data.code == "0000") {
          console.log(data);
          callBack(data);
          Toast.hide();
        }else {
          console.log(data.message);
          Toast.hide();
          Toast.info(data.message, 2);
        }
      }, (err) => {
        console.log("错误信息" + err);
        Toast.hide();
        Toast.info("错误信息" + err, 2);
      });
    });
  }
}

//获取规划题目
export function getEfficientQuestionnaire(params, callBack) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      params.token = token;
      Util.post(Util.url + "/api/v1/superfund/kyc/getEfficientQuestionnaire", params, (data) => {
        if(data.code == "0000") {
          console.log(data);
          callBack(data);
          Toast.hide();
        }else {
          console.log(data.message);
          Toast.hide();
          Toast.info(data.message, 2);
        }
      }, (err) => {
        console.log("错误信息" + err);
        Toast.hide();
        Toast.info("错误信息" + err, 2);
      });
    });
  }
}

//保存题目
export function addUserAnswerByZt(params, callBack) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      Util.postNew(Util.url + "/api/v1/superfund/kyc/addUserAnswer?token=" + token, params, (data) => {
        if(data.code == "0000") {
          console.log(data);
          callBack(data);
        }else {
          console.log(data.message);
          Toast.hide();
          Toast.info(data.message, 2);
        }
      }, (err) => {
        console.log("错误信息" + err);
        Toast.hide();
        Toast.info("错误信息" + err, 2);
      });
    });
  }
}

// 证通鉴权
export function ZTbool(params,_this,callback){
  return function(dispatch, getState) {
    Toast.loading('', 0, () => {});
    Util.get(Util.url+"/api/certificate/valid/ztValid",params,function(res){
      if(res.code == "0000"){
        callback(res.content);
      }else{
        Toast.hide();
        Toast.info(res.message, 2);
      }
    },function(error){
      console.log(error)
      Toast.hide();
      Toast.info("错误信息" + error, 2 );
    })
  }
}

//根据规划返回产品
export function getRcommendStrategy(params, callBack) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      params.token = token;
      Util.post(Util.url + "/api/v1/superfund/kyc/getRcommendStrategy", params, (data) => {
        if(data.code == "0000") {
          console.log(data);
          //管家过滤部分产品&重新计算匹配
          if(navigator.userAgent.toLowerCase() && navigator.userAgent.toLowerCase().indexOf("amcfmapp") != -1) {
            if(data && data.content && data.content.allStrategyList && data.content.allStrategyList.length > 0) {
              data.content.allStrategyList = [].concat(matchFundFunByGJOther(data.content.allStrategyList));
            }
            if(data && data.content && data.content.partMateStrategyList && data.content.partMateStrategyList.length > 0) {
              data.content.partMateStrategyList = [].concat(matchFundFunByGJOther(data.content.partMateStrategyList));
            }
            if(data && data.content && data.content.allStrategyList && data.content.partMateStrategyList) {
              data.content.mateAll = matchArrByAllArrOther(data.content.allStrategyList, data.content.partMateStrategyList);
            }
          }
          callBack(data);
          Toast.hide();
        }else {
          console.log(data.message);
          Toast.hide();
          Toast.info(data.message, 2);
        }
      }, (err) => {
        console.log("错误信息" + err);
        Toast.hide();
        Toast.info("错误信息" + err, 2);
      });
    });
  }
}

//不规划直接查看产品
export function getSuperFundSeriesFun(params, callBack) {
  return function(dispatch, getState) {
    getTempInfo("shortToken").then((token) => {
      if(token === null || token === "" || token === undefined) {
        console.log("token为空");
      }else {
        params.token = token;
        Util.post(Util.url + "/api/v1/superfund/superFundSeries/list", params, (data) => {
          if(data.code == "0000") {
            console.log(data);
            //管家过滤部分产品&重新计算匹配
            if(navigator.userAgent.toLowerCase() && navigator.userAgent.toLowerCase().indexOf("amcfmapp") != -1) {
              if(data && data.content && data.content.allSuperFundSeries && data.content.allSuperFundSeries.length > 0) {
                data.content.allSuperFundSeries = [].concat(matchFundFunByGJAll(data.content.allSuperFundSeries));
              }
              if(data && data.content && data.content.riskMatchSuperFundSeries && data.content.riskMatchSuperFundSeries.length > 0) {
                data.content.riskMatchSuperFundSeries = [].concat(matchFundFunByGJAll(data.content.riskMatchSuperFundSeries));
              }
              if(data && data.content && data.content.allSuperFundSeries && data.content.riskMatchSuperFundSeries) {
                data.content.mateAll = matchArrByAllArrAll(data.content.allSuperFundSeries, data.content.riskMatchSuperFundSeries);
              }
            }
            callBack(data);
            Toast.hide();
          }else {
            console.log(data.message);
            Toast.hide();
            Toast.info(data.message, 2);
          }
        }, (err) => {
          console.log("错误信息" + err);
          Toast.hide();
          Toast.info("错误信息" + err, 2);
        });
      }
    });
  }
}

const matchArrByAllArrAll = (allList, otherList) => {
  if(allList.length == otherList.length) {
    if(allList.length == 0) {
      return true;
    }else {
      let count = 0;
      for(let i = 0; i < allList.length; i++) {
        for(let s = 0; s < otherList.length; s++) {
          if(allList[i].seriesId === otherList[s].seriesId && allList[i].superFundList.length == otherList[s].superFundList.length) {
            count++;
          }
        }
      }
      if(count == allList.length) {
        return true;
      }else {
        return false;
      }
    }
  }else {
    return false;
  }
}

const matchArrByAllArrOther = (allList, otherList) => {
  if(allList.length == otherList.length) {
    if(allList.length == 0) {
      return true;
    }else {
      let count = 0;
      for(let i = 0; i < allList.length; i++) {
        for(let s = 0; s < otherList.length; s++) {
          if(allList[i].sceneId === otherList[s].sceneId && allList[i].superFundProductViewList.length == otherList[s].superFundProductViewList.length) {
            count++;
          }
        }
      }
      if(count == allList.length) {
        return true;
      }else {
        return false;
      }
    }
  }else {
    return false;
  }
}


const matchFundFunByGJAll = (arrList) => {
  let newArrList = [];
  for(let i = 0; i < arrList.length; i++) {
    let theArr = [].concat(matchFundFunByGJPub(arrList[i].superFundList));
    if(theArr.length > 0) {
      arrList[i].superFundList = [].concat(theArr);
      newArrList.push(arrList[i]);
    }
  }
  return newArrList;
}

const matchFundFunByGJOther = (arrList) => {
  let newArrList = [];
  for(let i = 0; i < arrList.length; i++) {
    let theArr = [].concat(matchFundFunByGJPub(arrList[i].superFundProductViewList));
    if(theArr.length > 0) {
      arrList[i].superFundProductViewList = [].concat(theArr);
      newArrList.push(arrList[i]);
    }
  }
  return newArrList;
}

const matchFundFunByGJPub = (allList) => {
  const newAllList = [];
  for(let i = 0; i < allList.length; i++) {
    if(Util.kycFundListByGJ.indexOf(allList[i].superFundCode) != -1) {
      newAllList.push(allList[i]);
    }
  }
  return newAllList;
}

//智投交易撤单
export function superfundCancelFun(data, sucCallBack, errback){
  return function(dispatch, getState){
    getTempInfo( 'shortToken' ).then( (d)=>{ 
      data.token = d;
      dispatch(validateTransactionPassword(data,(c)=>{
        if (!c) {errback();Toast.info( '交易密码错误', Util.ToastTime );return;}
        Util.get(Util.url+"/api/trade/doWithdraw",data,function(result){
          console.log(result);
          if (result.code=='0000') {
            sucCallBack(1, result);
          }else{
            sucCallBack(3, result.message);
            Toast.info( result.message, Util.ToastTime )
          }
        },function(error){
          sucCallBack(3, Util.errorTxt);
          Toast.info( Util.errorTxt, Util.ToastTime );   
        })
      },(m)=>{
          sucCallBack(3, m);
          Toast.info( m, Util.ToastTime )
      }))
    }).catch( (err)=>{ 
      console.log(err)
      errback();
    } )
  }
}


// WEBPACK FOOTER //
// ./src/action/investmentAction.js